import '../assets/css/bookingList.less';
// react
import React, { useEffect, useState, useMemo } from 'react';
// components
import { Button, Modal } from 'antd';
import BookingHeader from '../components/bookingHeader';
import BookingListContainer from '../components/bookingListContainer';
import { getNewDict, getListAndPermission, getOtherTeam } from '../api/request';
import { getValue, parseUrl } from '../utils';

const BookingList = () => {
    const { evaluationReportId, projectId, teamType } = parseUrl();

    const [myBookingList, setMyBookingList] = useState([]);
    const [moreBookingList, setMoreBookingList] = useState([]);
    const handleGetAllTeam = async () => {
        const { data } = await getOtherTeam({
            teamType: evaluationReportId ? 2 : 1
        });
        if (data.status === 0) {
            setMoreBookingList(data.result.other);
        }
    };
    /**
     * @description 获取预约列表
     */
    const getBookingList = async () => {
        let tempProjectId;
        if (projectId) {
            const { data: { status, result } } = await getNewDict({
                isDelete: false,
                typeIds: [1602]
            });
            if (status === 0 && result.length) {
                tempProjectId = result.filter(item => item.dictionaryId === projectId)[0].id;
            }
        }
        // 测评-2 普通预约-1
        const { data } = await getListAndPermission({
            teamType: teamType || evaluationReportId ? 2 : 1,
            projectId: tempProjectId
        });
        if (data.status) {
            Modal.info({
                title: data.info || data.message,
                okText: '确定',
                onOk: () => handleGetAllTeam()
            });
            return;
        }
        if (!data.status) {
            const serviceList = getValue(() => data.result.service) || [];
            const otherList = getValue(() => data.result.other) || [];
            setMyBookingList(serviceList);
            setMoreBookingList(otherList);
        }
    };

    useEffect(() => {
        getBookingList();
    }, []);

    return (
        <div className="booking-list">
            {/* 头部 */}
            <BookingHeader />
            {/* 内容 */}
            <div className="booking-list-wrapper">
                <div className="tips-header">
                    <img
                        className="header-img"
                        src="https://simg01.gaodunwangxiao.com/uploadfiles/tmp/upload/202206/06/be5cd_20220606155452.png" />
                    <span className="tips-title">定制课程，私教一对一服务，找到您的专属辅导老师</span>
                    <Button
                        onClick={() => window.open('https://muses.gaodun.com/ape/propagate-page')}
                        type="primary"
                    >
                        查看介绍
                    </Button>
                </div>
                <div className="booking-list-title">私教服务预约平台</div>
                <div className="booking-list-subtitle">您的私人老师，随时给你服务</div>
                {/* 我的服务 */}
                <BookingListContainer
                    bookingList={myBookingList}
                    title={'我的服务'}
                    type={'my'} />
                {/* 更多服务 */}
                {
                    !teamType && (
                        <BookingListContainer
                            bookingList={moreBookingList}
                            title={'更多服务'}
                            type={'more'} />
                    )
                }
            </div>
        </div>
    );
};

export default BookingList;